export default __webpack_public_path__ + "static/media/0_roadmap.d345d45f.png";